import { all, takeLatest, select, fork, join } from 'redux-saga/effects';
import { pushRouterState } from '../../router/sagas/RouterSagas';
import { BrandListerActionTypes } from '../../../enums/ActionEnums';
export const getModuleState = state => ({
    brandLister: state.brandLister,
});
export function* updateBrandListerFilterSaga() {
    yield takeLatest(BrandListerActionTypes.SET_FILTER, updateBrandListerFilter);
}
export function* updateBrandListerFilter(action) {
    const partialRootState = yield select(getModuleState);
    const pushingRouterStateTask = yield fork(pushRouterState, {
        filter: action.payload,
    }, Object.assign({}, partialRootState));
    yield join(pushingRouterStateTask);
}
export default function* brandListerSaga() {
    yield all([updateBrandListerFilterSaga()]);
}
